import type { FC, ReactNode } from 'react';
import clsx from 'clsx';

import { Show } from './Show';

interface ChipProps {
  children: ReactNode;
  'data-testid'?: string;
  dot?: boolean;
  className?: string;
}

export const Chip: FC<ChipProps> = ({ children, className, dot, 'data-testid': dataTestId }) => (
  <div
    data-testid={dataTestId}
    className={clsx('bg-primary-200/50 text-primary-700 flex items-center gap-1 rounded-full px-2 py-0.5', className)}
  >
    <Show when={dot}>
      <span className="bg-primary-300 h-1.5 w-1.5 rounded-full" />
    </Show>
    {children}
  </div>
);
